import Cookies from 'js-cookie';

import { Capacitor } from '@capacitor/core';
import { isPlatform } from '@ionic/react';

import { environment } from '../environment/environment';

export const BASE_ENDPOINT = {
  CA: environment.CAEndpoint,
  US: environment.USEndpoint,
};

export const US_REGION = `us-${environment.environment_deploy}`;

export const sample = <T>(array: T[] | undefined) => {
  const length = array == null ? 0 : array.length;
  return array && length ? array[Math.floor(Math.random() * length)] : undefined;
};

export const isNative = () => (isPlatform('ios') || isPlatform('android')) && !isPlatform('mobileweb');

export const getCustomIcon = (icon: string) => {
  let src = `assets/icons/${icon}.svg`;
  if (process.env.NODE_ENV === 'test') {
    src = 'public/' + src;
  }
  const url = new URL(src, window.location.origin);
  return url.href;
};

export const removeCookies = () => {
  const [_subdomain, rootDomain, topLevelDomain] = location.hostname.split('.');
  const CookiesAPI = Cookies.withAttributes({ path: '/', domain: `.${rootDomain}.${topLevelDomain}` });
  const names = Object.keys(CookiesAPI.get());
  for (const name of names) {
    CookiesAPI.remove(name);
  }
};

export const getIsOnline = async () => {
  let online = navigator.onLine;
  if (Capacitor.isPluginAvailable('Network')) {
    const { Network } = await import('@capacitor/network');
    online = (await Network.getStatus()).connected;
  }

  return online;
};
